import { Form, Header } from "semantic-ui-react";

import { Input } from "simplydo/react/component-library";

import util from "utils/utils";

import { FieldProps } from "./FieldProps";

const Assessment = ({
  field,
  fieldValue,
  isEditing,
  updateIdea,
  assessmentIsClosed,
}: FieldProps) => {
  if (!isEditing)
    return (
      <div>
        <Header size="tiny">Score</Header>
        {fieldValue} / {field.options.availableScore}
      </div>
    );

  return (
    <Form>
      <Form.Field
        control={Input}
        width="8"
        disabled={!isEditing || assessmentIsClosed}
        label={`Score (between 0 - ${field.options.availableScore})`}
        defaultValue={fieldValue ?? ""}
        placeholder="Enter a score..."
        onChange={(e) =>
          util.limitNumberInput(e, (val) =>
            updateIdea(
              val === "" ? val : (
                Math.max(0, Math.min(field.options.availableScore, val))
              ),
              ["assessment", field.id, "score"],
            ),
          )
        }
        type="number"
        min="0"
        max={String(field.options.availableScore)}
      />
    </Form>
  );
};

export default Assessment;
